// semeia-disable-reexport
import { action } from "@ember/object";
import Component from "@glimmer/component";

export interface FeelingEvasSlidersSignature {
  Element: HTMLDivElement;
  Args: { start: number | undefined; onChange?: () => void };
}

export default class FeelingEvasSectionContent<
  Signature
> extends Component<Signature> {
  /**
   * @see https://github.com/Microsoft/TypeScript/issues/3841#issuecomment-337560146
   */
  declare ["constructor"]: typeof FeelingEvasSectionContent;

  static min?: number;
  static max?: number;

  styles = {
    slider:
      "ui labeled ticked primary slider [&.ui.primary.slider_.inner_.track-fill]:bg-pink [&_i]:mb-[0.3em]",
    hints: "flex justify-between [&_span:last-child]:text-right"
  };

  @action
  labels(labels, value) {
    if (!labels[value]) return "";

    // HACK: using "&nbsp;" here to fix a positionning bug
    return "&nbsp;" + labels[value];
  }

  get min() {
    return this.constructor.min;
  }

  get max() {
    return this.constructor.max;
  }
}
